import { render, staticRenderFns } from "./EmployeeRelativeInformation.vue?vue&type=template&id=f7c1664a&"
import script from "./EmployeeRelativeInformation.vue?vue&type=script&lang=js&"
export * from "./EmployeeRelativeInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports